export default {
    // mounted() {
    //     if (this.gTagPageName) {
    //         let event = {
    //             event: `loaded-${this.gTagPageName}`
    //         };

    //         console.log(event);

    //         if (window.dataLayer !== undefined) {
    //             window.dataLayer.push(event);
    //         }
    //     }
    // },

    methods: {
        gTagEvent(eventName, data = {}) {
            if (window.gtag === undefined) {
                return;
            }
            
            window.gtag('event', eventName, data);
        }
    }
}